import React from "react";
import '../../styles/primarybutton.css'
import { Spin } from "antd";

const PrimaryButton = (props) => {
    return (
        <div className={props.secondary ? "secondary-button" : "primary-button"} onClick={() => { if (!props.isLoading) { props.onClick() } }}>
            {props.isLoading ? 
                <Spin></Spin> :
                <div>{props.label}</div>
            }
        </div>
    )
}
export default PrimaryButton;